"use strict";var E;exports.HyperLinkType=void 0,(E=exports.HyperLinkType||(exports.HyperLinkType={})).LINK_ONELINK_REDIRECTION="LINK_ONELINK_REDIRECTION",E.LINK_EXTERNAL_REDIRECTION="LINK_EXTERNAL_REDIRECTION",E.DEEPLINK="DEEPLINK";
//# sourceMappingURL=types.js.map
